<template lang="pug">
  .b-footer-support
    Icon._icon(name="support2")
    span._title(:class="{ grey: greyTitle }") Техническая поддержка 24/7
    a(href="mailto:support@teroom.ru")._email support@teroom.ru
</template>

<script>
export default {
  name: 'FooterSupport',
  props: {
    greyTitle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.footer-support {
  display: grid;
  grid-template-columns: min-content 1fr;
  align-items: center;
  padding: 7px 20px 10px;
  background-color: rgba(#090F17, 0.2);
  border-radius: 4px;
  column-gap: 6px;
  row-gap: 3px;

  &__icon {
    grid-row: 2 span;
  }

  &__title {
    font-size: 12px;
    line-height: 12px;
    grid-column: 2;
    align-self: end;

    &.grey {
      color: var(--color-light-dark);
    }
  }

  &__email {
    font-weight: 500;
    font-size: 13px;
    line-height: 13px;
    display: flex;
    color: #33A1FB;
  }
}
</style>
